// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveTabController from "./active_tab_controller"
application.register("active-tab", ActiveTabController)

import Admin__Auctions__BroadcastController from "./admin/auctions/broadcast_controller"
application.register("admin--auctions--broadcast", Admin__Auctions__BroadcastController)

import Admin__Auctions__FormController from "./admin/auctions/form_controller"
application.register("admin--auctions--form", Admin__Auctions__FormController)

import Admin__Auctions__MillicastViewCountController from "./admin/auctions/millicast_view_count_controller"
application.register("admin--auctions--millicast-view-count", Admin__Auctions__MillicastViewCountController)

import Admin__Auctions__TimeController from "./admin/auctions/time_controller"
application.register("admin--auctions--time", Admin__Auctions__TimeController)

import Admin__Auctions__UploadAssignmentsSectionController from "./admin/auctions/upload_assignments_section_controller"
application.register("admin--auctions--upload-assignments-section", Admin__Auctions__UploadAssignmentsSectionController)

import Admin__Auctions__Uploads__FormController from "./admin/auctions/uploads/form_controller"
application.register("admin--auctions--uploads--form", Admin__Auctions__Uploads__FormController)

import Admin__BookingContactFormController from "./admin/booking_contact_form_controller"
application.register("admin--booking-contact-form", Admin__BookingContactFormController)

import Admin__Bookings__ConfirmationFormController from "./admin/bookings/confirmation_form_controller"
application.register("admin--bookings--confirmation-form", Admin__Bookings__ConfirmationFormController)

import Admin__BulkSelectController from "./admin/bulk_select_controller"
application.register("admin--bulk-select", Admin__BulkSelectController)

import Admin__Lots__AdminBidFormController from "./admin/lots/admin_bid_form_controller"
application.register("admin--lots--admin-bid-form", Admin__Lots__AdminBidFormController)

import Admin__Lots__BidFormSubmitController from "./admin/lots/bid_form_submit_controller"
application.register("admin--lots--bid-form-submit", Admin__Lots__BidFormSubmitController)

import Admin__Lots__BidTableController from "./admin/lots/bid_table_controller"
application.register("admin--lots--bid-table", Admin__Lots__BidTableController)

import Admin__Lots__Categories__FormController from "./admin/lots/categories/form_controller"
application.register("admin--lots--categories--form", Admin__Lots__Categories__FormController)

import Admin__Lots__ChoiceLotConfirmerController from "./admin/lots/choice_lot_confirmer_controller"
application.register("admin--lots--choice-lot-confirmer", Admin__Lots__ChoiceLotConfirmerController)

import Admin__Lots__ControlRowController from "./admin/lots/control_row_controller"
application.register("admin--lots--control-row", Admin__Lots__ControlRowController)

import Admin__Lots__FormController from "./admin/lots/form_controller"
application.register("admin--lots--form", Admin__Lots__FormController)

import Admin__Lots__KeyboardShortcutController from "./admin/lots/keyboard_shortcut_controller"
application.register("admin--lots--keyboard-shortcut", Admin__Lots__KeyboardShortcutController)

import Admin__Lots__ReservePriceOfferConfirmerController from "./admin/lots/reserve_price_offer_confirmer_controller"
application.register("admin--lots--reserve-price-offer-confirmer", Admin__Lots__ReservePriceOfferConfirmerController)

import Admin__Marketplace__AgentSignups__ApprovalModalController from "./admin/marketplace/agent_signups/approval_modal_controller"
application.register("admin--marketplace--agent-signups--approval-modal", Admin__Marketplace__AgentSignups__ApprovalModalController)

import Admin__Quotes__AuctionPriceFormController from "./admin/quotes/auction_price_form_controller"
application.register("admin--quotes--auction-price-form", Admin__Quotes__AuctionPriceFormController)

import Admin__Quotes__FormController from "./admin/quotes/form_controller"
application.register("admin--quotes--form", Admin__Quotes__FormController)

import Admin__Quotes__LogisticsPricingController from "./admin/quotes/logistics_pricing_controller"
application.register("admin--quotes--logistics-pricing", Admin__Quotes__LogisticsPricingController)

import Admin__Quotes__MarketingPackageController from "./admin/quotes/marketing_package_controller"
application.register("admin--quotes--marketing-package", Admin__Quotes__MarketingPackageController)

import Admin__Quotes__MarketingPackageFormController from "./admin/quotes/marketing_package_form_controller"
application.register("admin--quotes--marketing-package-form", Admin__Quotes__MarketingPackageFormController)

import Admin__Quotes__MarketingPackageIncludedItemController from "./admin/quotes/marketing_package_included_item_controller"
application.register("admin--quotes--marketing-package-included-item", Admin__Quotes__MarketingPackageIncludedItemController)

import Admin__Quotes__MarketingServiceController from "./admin/quotes/marketing_service_controller"
application.register("admin--quotes--marketing-service", Admin__Quotes__MarketingServiceController)

import Admin__Quotes__OptionController from "./admin/quotes/option_controller"
application.register("admin--quotes--option", Admin__Quotes__OptionController)

import Admin__Quotes__OptionsController from "./admin/quotes/options_controller"
application.register("admin--quotes--options", Admin__Quotes__OptionsController)

import Admin__Quotes__RequestFormController from "./admin/quotes/request_form_controller"
application.register("admin--quotes--request-form", Admin__Quotes__RequestFormController)

import Admin__Quotes__StatusController from "./admin/quotes/status_controller"
application.register("admin--quotes--status", Admin__Quotes__StatusController)

import Admin__SubscriptionPlanFormController from "./admin/subscription_plan_form_controller"
application.register("admin--subscription-plan-form", Admin__SubscriptionPlanFormController)

import Admin__Users__FormController from "./admin/users/form_controller"
application.register("admin--users--form", Admin__Users__FormController)

import Admin__Users__PermissionCheckBoxController from "./admin/users/permission_check_box_controller"
application.register("admin--users--permission-check-box", Admin__Users__PermissionCheckBoxController)

import AppBadgeController from "./app_badge_controller"
application.register("app-badge", AppBadgeController)

import AsyncContentController from "./async_content_controller"
application.register("async-content", AsyncContentController)

import AutoBidStatusController from "./auto_bid_status_controller"
application.register("auto-bid-status", AutoBidStatusController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutonumericController from "./autonumeric_controller"
application.register("autonumeric", AutonumericController)

import AutoplayCarouselController from "./autoplay_carousel_controller"
application.register("autoplay-carousel", AutoplayCarouselController)

import BidSelectController from "./bid_select_controller"
application.register("bid-select", BidSelectController)

import BillingProfileFormFieldsController from "./billing_profile_form_fields_controller"
application.register("billing-profile-form-fields", BillingProfileFormFieldsController)

import BillingProfileToggleController from "./billing_profile_toggle_controller"
application.register("billing-profile-toggle", BillingProfileToggleController)

import BlankAnchorTargetsController from "./blank_anchor_targets_controller"
application.register("blank-anchor-targets", BlankAnchorTargetsController)

import BlurController from "./blur_controller"
application.register("blur", BlurController)

import Bookings__AddonGroupFormController from "./bookings/addon_group_form_controller"
application.register("bookings--addon-group-form", Bookings__AddonGroupFormController)

import CatalogueSourceController from "./catalogue_source_controller"
application.register("catalogue-source", CatalogueSourceController)

import ClampController from "./clamp_controller"
application.register("clamp", ClampController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import Confirmations__ContentController from "./confirmations/content_controller"
application.register("confirmations--content", Confirmations__ContentController)

import CopyButtonController from "./copy_button_controller"
application.register("copy-button", CopyButtonController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CountryController from "./country_controller"
application.register("country", CountryController)

import CurrencySymbolController from "./currency_symbol_controller"
application.register("currency-symbol", CurrencySymbolController)

import DynamicFormFieldsController from "./dynamic_form_fields_controller"
application.register("dynamic-form-fields", DynamicFormFieldsController)

import DynamicHrefController from "./dynamic_href_controller"
application.register("dynamic-href", DynamicHrefController)

import FormAutoSubmitController from "./form_auto_submit_controller"
application.register("form-auto-submit", FormAutoSubmitController)

import GlobalAdmin__Tenants__InvoicesFormController from "./global_admin/tenants/invoices_form_controller"
application.register("global-admin--tenants--invoices-form", GlobalAdmin__Tenants__InvoicesFormController)

import GoogleAdsConversionController from "./google_ads_conversion_controller"
application.register("google-ads-conversion", GoogleAdsConversionController)

import GoogleMapsController from "./google_maps_controller"
application.register("google-maps", GoogleMapsController)

import HideReactNativeController from "./hide_react_native_controller"
application.register("hide-react-native", HideReactNativeController)

import ImageWithPlaceholderController from "./image_with_placeholder_controller"
application.register("image-with-placeholder", ImageWithPlaceholderController)

import InitialReactNativeTokenUpsertController from "./initial_react_native_token_upsert_controller"
application.register("initial-react-native-token-upsert", InitialReactNativeTokenUpsertController)

import InvitationController from "./invitation_controller"
application.register("invitation", InvitationController)

import LiveWrapperController from "./live_wrapper_controller"
application.register("live-wrapper", LiveWrapperController)

import Lots__ChoiceLotSelectorController from "./lots/choice_lot_selector_controller"
application.register("lots--choice-lot-selector", Lots__ChoiceLotSelectorController)

import Lots__CurrentBidAndBidButtonController from "./lots/current_bid_and_bid_button_controller"
application.register("lots--current-bid-and-bid-button", Lots__CurrentBidAndBidButtonController)

import Lots__HoverCounterController from "./lots/hover_counter_controller"
application.register("lots--hover-counter", Lots__HoverCounterController)

import Lots__WebcastController from "./lots/webcast_controller"
application.register("lots--webcast", Lots__WebcastController)

import MarketingListsModalController from "./marketing_lists_modal_controller"
application.register("marketing-lists-modal", MarketingListsModalController)

import Marketplace__AgentSignupFormController from "./marketplace/agent_signup_form_controller"
application.register("marketplace--agent-signup-form", Marketplace__AgentSignupFormController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalGalleryController from "./modal_gallery_controller"
application.register("modal-gallery", ModalGalleryController)

import MultipleSelectController from "./multiple_select_controller"
application.register("multiple-select", MultipleSelectController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import PopulateInvitationController from "./populate_invitation_controller"
application.register("populate-invitation", PopulateInvitationController)

import PreviewFormController from "./preview_form_controller"
application.register("preview-form", PreviewFormController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import ProvinceController from "./province_controller"
application.register("province", ProvinceController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import ReactNativeTokenBaseController from "./react_native_token_base_controller"
application.register("react-native-token-base", ReactNativeTokenBaseController)

import RedirectController from "./redirect_controller"
application.register("redirect", RedirectController)

import RequestNotificationPermissionModalController from "./request_notification_permission_modal_controller"
application.register("request-notification-permission-modal", RequestNotificationPermissionModalController)

import RequiredChoiceController from "./required_choice_controller"
application.register("required-choice", RequiredChoiceController)

import ResetFieldController from "./reset_field_controller"
application.register("reset-field", ResetFieldController)

import RichTextContentController from "./rich_text_content_controller"
application.register("rich-text-content", RichTextContentController)

import SaveButtonToggleController from "./save_button_toggle_controller"
application.register("save-button-toggle", SaveButtonToggleController)

import SelectColorizerController from "./select_colorizer_controller"
application.register("select-colorizer", SelectColorizerController)

import SelectHrefController from "./select_href_controller"
application.register("select-href", SelectHrefController)

import ShowPasswordController from "./show_password_controller"
application.register("show-password", ShowPasswordController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleVisibilityController from "./toggle_visibility_controller"
application.register("toggle-visibility", ToggleVisibilityController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TruncateController from "./truncate_controller"
application.register("truncate", TruncateController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import Users__AccountController from "./users/account_controller"
application.register("users--account", Users__AccountController)

import Users__FieldsController from "./users/fields_controller"
application.register("users--fields", Users__FieldsController)

import VideoReloadController from "./video_reload_controller"
application.register("video-reload", VideoReloadController)

import VisitController from "./visit_controller"
application.register("visit", VisitController)

import ZoomController from "./zoom_controller"
application.register("zoom", ZoomController)
